import React from "react";
import { Container } from "react-bootstrap";
import { GatsbyImage } from "gatsby-plugin-image";
import "../../styles/components/elements/phone_contact.scss";

const PhoneContact = ({ slice }) => {
  if (!slice) return null;
  const data = slice.items[0];

  return (
    <Container fluid className="contact-info-slice">
      <Container className="max-container py-5">
        <div className="pt-0 pb-md-5 py-md-5 justify-content-center d-md-flex">
          <div className="align-self-center text-center text-md-end">
            <GatsbyImage
              image={data.image.gatsbyImageData}
              alt={data.image.alt}
              style={{ height: "170px", width: "170px" }}
            />
          </div>
          <div className="align-self-center text-center text-md-start">
            <h4 className="mb-2 title">{data.title1.text}</h4>
            <h2 className="descr mb-2">
              <a href={`tel:+30${data.phone}`} className="color-main">
                {data.phone}
              </a>
            </h2>
            <p className="hours">{data.hours}</p>
          </div>
        </div>
      </Container>
    </Container>
  );
};

export default PhoneContact;
